import countries from 'src/data/country';

const auStates = {
  'new south wales': 'NSW',
  Queensland: 'QLD',
  'south australia': 'SA',
  tasmania: 'TAS',
  victoria: 'VIC',
  'western australia': 'WA',
  'australian capital Territory': 'ACT',
  'northern territory': 'NT'
};

const getState = function (_address) {
  if (_address.country.toLowerCase() === 'au' || _address.country.toLowerCase() === 'australia') {
    return auStates[_address.state.toLowerCase()] || _address.state.toUpperCase();
  } else {
    return _address.state;
  }
};

const validAddress = function (_address, countryCodeRestricted = '') {
  let countryRestricted;
  if (countryCodeRestricted) {
    countryRestricted = countries.find((c) => c.code === countryCodeRestricted);
  }
  if (
    !_address ||
    !_address instanceof Object ||
    !_address.country ||
    !_address.state ||
    !_address.city ||
    (!_address.address1 && !_address.address2) ||
    !_address.zip
  ) {
    return false;
  } else if (
    countryRestricted &&
    _address.country.toLowerCase() !== countryRestricted.name.toLowerCase() &&
    _address.country.toLowerCase() !== countryRestricted.code.toLowerCase()
  ) {
    return false;
  } else if (_address.country.toLowerCase() === 'au' || _address.country.toLowerCase() === 'australia') {
    return (
      Object.entries(auStates)
        .map((s) => s[1])
        .indexOf(getState(_address)) >= 0
    );
  } else {
    return true;
  }
};

export const convertStringAddress = (_address, defaultValue = '', countryCodeRestricted = '') => {
  if (!validAddress(_address, countryCodeRestricted)) return defaultValue;

  const address = `${_address?.address1 || ''} ${_address?.address2 || ''} ${_address?.address3 || ''} ${
    _address?.city || ''
  } ${_address?.state || ''} ${_address?.zip || ''} ${_address.country || ''}`;
  return (address && address.trim()) || defaultValue;
};

export default convertStringAddress;
